import { render, staticRenderFns } from "./CobraResources.vue?vue&type=template&id=723a0fc0&"
import script from "./CobraResources.vue?vue&type=script&lang=js&"
export * from "./CobraResources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports